import { Component, OnInit, Inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-taxationsettings',
  templateUrl: './taxationsettings.component.html',
  styleUrls: ['./taxationsettings.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class TaxationsettingsComponent implements OnInit {

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet) {
    
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

   }

  FromDate = new FormControl(moment());
  ToDate =  new FormControl(moment());
  NewTax: {[k: string]: any} = {};

  masterData:any;
  Countries:any[];
  TaxTypes:any[];
  searchTerm:string;

  ngOnInit(): void {
    this.GetMasterData();
    this.NewTax = null;
  }

  GetMasterData(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage()
   };
  
   this.parent.loading = true;
  
   this.service.GetMasterData(request).subscribe(response => {
  
     if(response["Status"] != 1){
     
     }
     else if(response["Status"] == 1){
      this.masterData = response;
      this.Countries = this.masterData.Countries.slice(0, 10);
      this.TaxTypes = this.masterData.TaxPayTypes;
     }
  
     this.parent.loading = false;
   });
  }

  GetCountryTaxations(id:number){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CountryID:id
   };
  
   this.parent.loading = true;
  
   this.service.GetCountryTaxations(request).subscribe(response => {
  
     if(response["Status"] != 1){
     
     }
     else if(response["Status"] == 1){
      var c = this.Countries.find(x => x.ID == id);
      c.Taxations = response["Taxations"];
      this.NewTax = null;
     }
  
     this.parent.loading = false;
   });
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

AddUpdateCountryTaxation(t:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Taxation:t
 };

 this.parent.loading = true;
  
 this.service.AddUpdateCountryTaxation(request).subscribe(response => {

   if(response["Status"] != 1){
    this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
   }
   else{
     this.GetCountryTaxations(t.CountryID);
   }

   this.NewTax = null;
   this.parent.loading = false;
 });
}

InitializeNewTax(c){
  this.NewTax = {};
  this.NewTax.CountryID = c.ID;
  this.NewTax.Type = this.TaxTypes[0];
  this.NewTax.PercentageTaxation = null;
  this.NewTax.ValueTaxation = null;
  this.NewTax.UpperYearlyThreshold = null;
  this.NewTax.FromAvailability = null;
  this.NewTax.ToAvailability = null;
}

}
